<template>
  <el-footer height="425px">
    <div class="footer-container">
      <div class="footer-content-info">
        <div class="footer-content" v-for="section in FooterMenu" :key="section.label">
            <div class="footer-content-title">
              {{ $t(section.label) }}
            </div>
            <div class="footer-content-div" v-for="item in section.children" :key="item.label">
              <a class="footer-content-text" :href="item.link">{{ $t(item.label) }}</a>
            </div>
        </div>
        <div class="footer-content footer-content-last">
          <div class="footer-content-div" v-for="item in TopMenu" :key="item.label">
            <a class="footer-content-text-last" :href="item.link">{{ $t(item.label) }}</a>
          </div>
        </div>
      </div>

      <div class="footer-link">
        <div style="display: inline-block">
          <a href="https://twitter.com/OntologyNetwork"
            ><img
              class="footer-link-twitter footer-link-img"
              src="../../assets/img/footer/twitter@2x.png"
          /></a>
          <a href="https://twitter.com/OntologyJP"
            ><img
              class="footer-link-telegram footer-link-img"
              src="../../assets/img/footer/twitterJP@2x.png"
          /></a>
          <a href="https://www.facebook.com/ONTnetwork/"
            ><img
              class="footer-link-facebook footer-link-img"
              src="../../assets/img/footer/facebook@2x.png"
          /></a>
          <a
            href="https://www.linkedin.com/company/ontology-network-official/"
            ><img
              class="footer-link-linkedin footer-link-img"
              src="../../assets/img/footer/linkedin@2x.png"
          /></a>
          <a href="https://medium.com/ontologynetwork"
            ><img
              class="footer-link-medium footer-link-img"
              src="../../assets/img/footer/medium@2x.png"
          /></a>
          <a href="https://t.me/OntologyAnnouncements"
            ><img
              class="footer-link-telegram footer-link-img"
              src="../../assets/img/footer/telegram@2x.png"
          /></a>
          <a href="https://www.reddit.com/r/OntologyNetwork/"
            ><img
              class="footer-link-reddit footer-link-img"
              src="../../assets/img/footer/reddit@2x.png"
          /></a>
          <a href="https://www.youtube.com/channel/UCXzLZJgDglAWRU0b2GOa7pA"
            ><img
              class="footer-link-reddit footer-link-img"
              src="../../assets/img/footer/youtube.png"
          /></a>
          <a href="https://discord.com/invite/4SrrJy2zHe"
            ><img
              class="footer-link-discord footer-link-img"
              src="../../assets/img/footer/discord@2x.png"
          /></a>
          <a href="https://github.com/ontio"
            ><img
              class="footer-link-github footer-link-img"
              src="../../assets/img/footer/github@2x.png"
          /></a>
        </div>
      </div>
      <div class="footer-copyright">
        © 2018 - 2024 Ontology. All rights reserved
      </div>
    </div>
  </el-footer>
</template>

<script>
import { FooterMenu, TopMenu } from "../constant";
export default {
  name: "PcFooter",
  data() {
    return {
      FooterMenu,
      TopMenu
    }
  }
};
</script>

<style scoped>
.el-footer {
  padding: 0;
  background: #051432;
  min-width: 1140px;
  text-align: left;
  padding-top: 60px;
}
.footer-copyright {
  margin-top: 20px;
}
.footer-container {
  max-width: 1200px;
  min-width: 900px;
  margin: auto;
}

.footer-width {
  width: 944px;
}
.footer-logo-title {
  margin-bottom: 25px;
}
.footer-logo-img {
  height: 18px;
  width: 16px;
  transform: translateY(3px);
}
.footer-logo-text {
  font-size: 18px;
  font-weight: 400;
  color: #595757;
  line-height: 23px;
}
.footer-logo-label {
  opacity: 0.2;
  color: black;
  margin-left: 16px;
  margin-right: 16px;
}
.footer-content-info {
  display: flex;
  justify-content: space-between;
}
.footer-content {
  /*     width: 224px; */
  /* width: 24%; */
  display: inline-block;
  vertical-align: top;
}
.footer-content-title {
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  line-height: 135%;
}
.lang_en .footer-content-title {
  font-family: NunitoSans-Bold, "Avenir", Helvetica, Arial, sans-serif;
}
.footer-content-div {
  margin-top: 14px;
}
.footer-content-last .footer-content-div:first-child{
  margin-top: 0;
}
.footer-content-text {
  font-size: 14px;
  font-weight: 300;
  color: #ffffff !important;
  line-height: 135%;
  cursor: pointer;
}
.footer-content-text-last {
  font-weight: 500;
  font-size: 18px;
  color: #ffffff !important;
  line-height: 135%;
  cursor: pointer;
}
.footer-content-text-last:hover {
  color: #2fa3f1 !important;
}
.footer-content-text-active {
  font-size: 14px;
  font-weight: 400;
  color: #595757 !important;
  line-height: 18px;
  cursor: pointer;
}
.footer-content-text:hover {
  color: #2fa3f1 !important;
}
.footer-content-text:active {
  color: #afacac !important;
}
.footer-language {
  margin-top: 34px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-language-content {
  display: inline-block;
  vertical-align: top;
}
.footer-line {
  height: 1px;
  border-bottom: 1px solid #afacac;
  margin-top: 25px;
}
.footer-link {
  text-align: center;
  margin-bottom: 24px;
}
.footer-link-telegram {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.footer-link-discord {
  width: 16px;
  height: 16px;
}
.footer-link-twitter {
  width: 16px;
  height: 16px;
}
.footer-link-facebook {
  width: 16px;
  height: 16px;
}
.footer-link-reddit {
  width: 16px;
  height: 16px;
}
.footer-link-medium {
  width: 16px;
  height: 16px;
}
.footer-link-email {
  width: 16px;
  height: 16px;
}
.footer-link-github {
  width: 16px;
  height: 16px;
}
.footer-link-linkedin {
  width: 16px;
  height: 16px;
}
.footer-link-img {
  cursor: pointer;
  margin-top: 40px;
  margin-left: 13px;
  margin-right: 13px;
}
.footer-link-img:hover,
.footer-link-img:active {
  opacity: 1;
}
.footer-copyright {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  /* padding-bottom: 40px; */
  font-weight: 300;
  line-height: 135%;
}
</style>
